import React, { createContext, useMemo, useState } from 'react'
import type { MenuContextProps } from '../../../types/types'
import { ChildContainerProps } from '../../../types/types'

export const MenuContext = createContext({} as MenuContextProps)
export const MenuProvider = (props: ChildContainerProps) => {
    const [activeMenu, setActiveMenu] = useState('')

    const value = useMemo(
        () => ({
            activeMenu,
            setActiveMenu,
        }),
        [activeMenu, setActiveMenu],
    )

    return <MenuContext.Provider value={value}>{props.children}</MenuContext.Provider>
}
